export const MESSAGES_UPDATE_LIST = 'MESSAGES_UPDATE_LIST'
export const MESSAGES_UPDATE_ITEM = 'MESSAGES_UPDATE_ITEM'
export const MESSAGES_SET_FETCHING = 'MESSAGES_SET_FETCHING'
export const MESSAGES_POST_SAGA_MESSAGE = 'MESSAGES_POST_SAGA_MESSAGE'
